import React from 'react';
import { Button } from '../ui/button';
import { Plus } from 'lucide-react';
import { t } from '../../lib/i18n';

export const ChatHeader = ({ language, onNewSession }) => (
  <div className="flex items-center justify-between px-4 sm:px-6 py-3 border-b border-white/[0.06] bg-lux-obsidian/50 backdrop-blur-md" data-testid="chat-header">
    <div className="flex items-center gap-3">
      <img src="/logo.jpeg" alt="PrimeFace" className="w-9 h-9 rounded-lg object-cover border border-lux-gold/30" />
      <div>
        <h2 className="text-sm font-semibold text-white">{t('coach', language)}</h2>
        <p className="text-xs text-white/40">PrimeFace</p>
      </div>
    </div>
    <Button
      data-testid="new-session-button"
      onClick={onNewSession}
      variant="ghost"
      className="text-white/50 hover:text-white hover:bg-white/5"
      size="sm"
    >
      <Plus className="w-4 h-4 mr-1" /> {t('newSession', language)}
    </Button>
  </div>
);
